module.exports = __webpack_public_path__ + "89917dbdece5f8cc4368e5fec0368ace.MP3";